module.exports = __webpack_public_path__ + "img/14.4f0ab968.png";